import { isStagingSite } from './site';

/** Canonical production HELM origin */
export const PRODUCTION_ORIGIN = 'https://helm.wildwoodmfg.com';

/** Canonical staging HELM origin */
export const STAGING_ORIGIN = 'https://staging.helm.wildwoodmfg.com';

/**
 * Origin for the opposite environment of the current site.
 * Staging → production; production (and local/dev) → staging.
 */
export const getAlternateEnvironmentOrigin = (): string => (
  isStagingSite() ? PRODUCTION_ORIGIN : STAGING_ORIGIN
);

/**
 * Same path/query/hash on the opposite environment.
 * Used by the admin “Open in Staging/Production” shortcut.
 */
export const getAlternateEnvironmentUrl = (
  pathWithSearchAndHash: string = `${window.location.pathname}${window.location.search}${window.location.hash}`,
): string => {
  const path = pathWithSearchAndHash.startsWith('/')
    ? pathWithSearchAndHash
    : `/${pathWithSearchAndHash}`;
  return `${getAlternateEnvironmentOrigin()}${path}`;
};

export const getAlternateEnvironmentLabel = (): string => (
  isStagingSite() ? 'Open in Production' : 'Open in Staging'
);
